import { keepPreviousData } from "@tanstack/react-query";
import { RouterOutputs, trpc } from "../trpc";

export type ImplementationMeta =
  RouterOutputs["implementationMeta"]["queryImplementationsMeta"][number];

interface Input {
  term?: string;
}

interface Options {
  enabled?: boolean;
}

export function useQueryImplementationsMeta(
  { term }: Input,
  { enabled = true }: Options = {},
) {
  const { data, isFetching, isLoading, isPlaceholderData } =
    trpc.implementationMeta.queryImplementationsMeta.useQuery(
      {
        term: term || "",
      },
      {
        enabled: !!term && enabled,
        placeholderData: keepPreviousData,
      },
    );

  return {
    implementationsMeta: data || [],
    isLoading,
    isFetching,
    isPlaceholderData,
  };
}
